export default __webpack_public_path__ + "static/media/waypoint-icon.a5fd2a0a.svg";